import * as yup from 'yup';

export const subOrgUnitSchema = yup.object().shape({
    name: yup.string().required('Requis'),
    orgUnit: yup.object().nullable().required('Requis'),
    tenant: yup.object().nullable().required('Requis'),
});